var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.1105 1.14285C33.6271 1.14285 33.1437 1.35353 32.775 1.77636L19.4989 16.9481L6.225 1.77787C5.48634 0.933683 4.29264 0.933683 3.55399 1.77787C2.81534 2.62205 2.81534 3.98629 3.55399 4.83048L16.8278 20.0008L3.55399 35.171C2.81534 36.0152 2.81534 37.3794 3.55399 38.2236C3.92268 38.645 4.40607 38.8556 4.8895 38.8556C5.37289 38.8556 5.85632 38.6435 6.225 38.2236L19.4989 23.0533L32.775 38.2251C33.1437 38.6465 33.6271 38.8571 34.1105 38.8571C34.5939 38.8571 35.076 38.645 35.446 38.2251C36.1847 37.3809 36.1847 36.0167 35.446 35.1725L22.1698 20.0008L35.446 4.82897C36.1847 3.98478 36.1847 2.62054 35.446 1.77636C35.0773 1.35353 34.5939 1.14285 34.1105 1.14285Z","fill":"black"}));
}

X.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = X;

X.default = X;
